// eslint-disable-next-line monorepo/no-internal-import
import {AsyncPageTrackingContextProvider} from '@aboutyou/legacy-desktop/src/app/helpers/tracking/AsyncPageTrackingContext';
import {
  AuthenticationProvider,
  NotificationProvider,
} from '@aboutyou/logic-components';
import React from 'react';
import {
  LegacyAuthSyncProvider,
  useHandleOnSyncLegacy,
} from '../bridge/LegacyAuthSyncProvider';
import {LegacyStateProvider} from '../bridge/SyncLegacyStateContext';

export const AppProviders: React.FC<React.PropsWithChildren> = ({children}) => {
  return (
    <LegacyAuthSyncProvider>
      <Content>{children}</Content>
    </LegacyAuthSyncProvider>
  );
};

const Content: React.FC<React.PropsWithChildren> = ({children}) => {
  // A manual call to sync legacy on desktop is required in favor of using the
  // bi-directional syncs from the sync-state-hooks functions.
  // The `AuthenticationProvider` would invoke the `onSyncLegacy` callback on login-success every time.
  const handleOnSyncLegacy = useHandleOnSyncLegacy();

  return (
    <AsyncPageTrackingContextProvider>
      <LegacyStateProvider>
        <NotificationProvider>
          <AuthenticationProvider onSyncLegacy={handleOnSyncLegacy}>
            {children}
          </AuthenticationProvider>
        </NotificationProvider>
      </LegacyStateProvider>
    </AsyncPageTrackingContextProvider>
  );
};
